import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.8327 9.99996C18.8327 5.39759 15.1017 1.66663 10.4993 1.66663C5.89698 1.66663 2.16602 5.39759 2.16602 9.99996C2.16602 14.6023 5.89698 18.3333 10.4993 18.3333C15.1017 18.3333 18.8327 14.6023 18.8327 9.99996ZM7.41009 8.57737C7.08466 8.90281 7.08466 9.43045 7.41009 9.75588C7.73553 10.0813 8.26317 10.0813 8.5886 9.75588L9.66602 8.67847V13.3333C9.66602 13.7935 10.0391 14.1666 10.4993 14.1666C10.9596 14.1666 11.3327 13.7935 11.3327 13.3333V8.67847L12.4101 9.75588C12.7355 10.0813 13.2632 10.0813 13.5886 9.75588C13.914 9.43045 13.914 8.90281 13.5886 8.57737L11.0886 6.07737C10.7632 5.75193 10.2355 5.75193 9.91009 6.07737L7.41009 8.57737Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }